import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = () => ({
  products: [],
});

export default {
  state,
  getters,
  actions,
  mutations,
};
